import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import Divider from "components/divider";
import FormLayout from "components/form/FormLayout";
import Toggle from "components/form/toggle/Toggle";
import Input from "components/form/input/Input";
import React from "react";
import { useTranslation } from "react-i18next";
import "./facilitySettings.scss";

interface IProps {
  state: Partial<IPutTeeSheetSettings>;
  table: IQuickStaleTableState;
  updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
  updateTableState: (title: string) => void;
}

interface IQuickStaleTableState {
  id: number;
  title: string;
  originalTitle: string;
}

export default function FacilityTableServiceSettings(props: IProps) {
  const { state, table, updateState, updateTableState } = props;
  const { t } = useTranslation();

  return (
    <div className="facility-settings-section p-2">
      <div className="facility-settings-toggle-stack">
        <Toggle
          labelRight={t("Clock-in required")}
          labelSupport={t("Staff must clock-in before using table service.")}
          onChange={e => updateState("table_service_clock_in", e.target.checked)}
          checked={state?.table_service_clock_in}
        />
        <Toggle
          labelRight={t("Send kitchen chits when leaving a table")}
          labelSupport={t(
            "Automatically send unsent kitchen chits when staff backs out of a table or switches to another table",
          )}
          onChange={e => updateState("table_service_send_chits", e.target.checked)}
          checked={state?.table_service_send_chits}
        />
      </div>

      <Divider />

      <FormLayout>
        <FormLayout.Group>
          <Input
            label={t("Quick sale table title")}
            value={table?.title}
            onChange={e => updateTableState(e.target.value)}
            helpText={t("Enter the table title shown on kitchen chits.")}
          />
        </FormLayout.Group>
      </FormLayout>
    </div>
  );
}
